module.exports = __webpack_public_path__ + "static/media/pcc.67a21a4a.jpg";